<section id="coverage-type-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Coverage Type Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="coverageTypeTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="coverage-type-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.coverageTypeForm" class="form">
                <div id="coverage-type-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Coverage Type Code</label>
                    </div>
                    <div class="">
                        <input formControlName="coverageTypeCdDisp" type="text" readonly>
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                                {{activeType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>Coverage Type</label>
                    </div>
                    <div class="">
                        <input formControlName="coverageTypeDesc" type="text" maxlength="30">
                    </div>
                    <div class="field required">
                        <label>Renew</label>
                    </div>
                    <div class="">
                        <select formControlName="renewTag">
                            <option *ngFor="let renewType of selections.renewTypes" [value]="renewType.cd">
                                {{renewType.name}}
                            </option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>BPIMS Code</label>
                    </div>
                    <div class="">
                        <input formControlName="bmCode" type="text" maxlength="8">
                    </div>
                    <div class="field">
                        <label>BPIMS Short Description</label>
                    </div>
                    <div class="">
                        <input formControlName="bmShortDesc" type="text" maxlength="10">
                    </div>
                    
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="4000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.coverageType.updateDisabled" class="btn btn2" type="button" (click)='onAdd()'>ADD</button>
                <button *ngIf="!btns.coverageType.updateDisabled" class="btn btn2" type="button" (click)='onUpdate()'>UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.coverageType.deleteDisabled' (click)='onDelete()'> DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.coverageType.saveDisabled' (click)='onSave()'>SAVE</button>
            </div>
        </div>
    </div>
</section>